import * as React from "react";

import { useDispatch } from "react-redux";
import { showNavbar } from "../../store/modules/appStateSlice";
import { IAppPropsWithRoute } from "../../common/types";
import LoginWidget from "./LoginWidget";
import { withRouter } from "react-router-dom";
import { useState } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import LoginOTP from "./LoginOTP";
import { Action, ThunkDispatch } from "@reduxjs/toolkit";
import { formatToken, getRoles } from "./loginHelpers";
import useWindowSize from "../shared/useWindowSize";
import LoginWidgetForTablets from "./loginForMobile/LoginWidgetForTablets";
import LoginOTPForTablets from "./loginForMobile/LoginOTPForTablets";

import { ILoginState } from "./types/authTypes";
import { isItTablet1280x800inLandscape } from "../../common/helpers";

interface LoginPageProps extends IAppPropsWithRoute {}

const useStyles = makeStyles((theme: Theme) => ({}));

function LoginPage(props: LoginPageProps): JSX.Element {
  const dispatch = useDispatch();
  const dispatchThunk = useDispatch<ThunkDispatch<any, any, Action>>();
  const classes = useStyles();

  const { windowWidth } = useWindowSize();

  const initialLoginState: ILoginState = {
    Step: 0,
    Username: "",
    Password: "",
    isSMS: false,
  };
  const [loginState, setLoginState] = useState<ILoginState>(initialLoginState);

  React.useEffect(() => {
    // const existingSession = localStorage.getItem("persist:root");
    // if (existingSession !== null && existingSession !== "")
    // {
    //   if (JSON.parse(JSON.parse(existingSession).authStore).isAuthenticated)
    //     props.history.push("/");
    //   else
    //     dispatch(showNavbar(false));
    // }
    // else
      dispatch(showNavbar(false));
  }, []);

  const navigate = (isSuccess: boolean, token: string) => {
    if (isSuccess) {
        props.history.push("/");
    }
  };

  const finishLogin = (isSuccess: boolean, token: string): void => {
    navigate(isSuccess, token);
  };

  const goToForgotPassword = () => {
    props.history.push("/reset-password");
  };

  const goToLoginOTP = (username: string, password: string, isSMS: boolean): void => {
    setLoginState({
      Step: 1,
      Username: username,
      Password: password,
      isSMS,
    });
  };

  const handleFinishLoginOTP = (isSuccess: boolean, token: string): void => {
    navigate(isSuccess, token);
  };


  const createStandardLoginControl = (): JSX.Element => {
    if (loginState.Step == 0) {
      return <LoginWidget finishLogin={finishLogin} goToForgotPassword={goToForgotPassword} 
      goToLoginOTP={goToLoginOTP} />;
    } else {
      return (
        <LoginOTP
          finishLoginOTP={handleFinishLoginOTP}
          username={loginState.Username}
          password={loginState.Password}
          dispatch={dispatchThunk}
          isSMS={loginState.isSMS}
        />
      );
    }
  };

  const createTabletLoginControl = (): JSX.Element => {
    if (loginState.Step == 0) {
      return <LoginWidgetForTablets finishLogin={finishLogin} goToForgotPassword={goToForgotPassword} goToLoginOTP={goToLoginOTP} />;
    } else {
      return (
        <LoginOTPForTablets
          finishLoginOTP={handleFinishLoginOTP}
          username={loginState.Username}
          password={loginState.Password}
          dispatch={dispatchThunk}
          isSMS={loginState.isSMS}
          initialLoginState={initialLoginState}
          setLoginState={setLoginState}
        />
      );
    }
  };

  return isItTablet1280x800inLandscape(windowWidth) ? createTabletLoginControl() : createStandardLoginControl();
}

export default React.memo(withRouter(LoginPage));
